import standard from './standard'
import portfolio from './portfolio'
import finance from './finance'

export default {
  standard,
  portfolio,
  finance
}
